import {styled, Box} from 'external/material'
import {centerVertically} from 'utils/style'
import Grades from './Grades'

const StyledGrades = styled(Box)(gradesStyles)
export default function GradesPage() {
  console.log(Grades)
  return (
    <StyledGrades className="container">
        <Grades />
    </StyledGrades>
  )
}

function gradesStyles() {
  return {
    "& .grades": {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      backgroundColor: '#fff',
      borderRadius: 5,
      transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px',
      "& .nameCell": {
        display: 'flex'
      },
      "& .gradeName": {
        marginLeft: 10,
        color: '#6b748c',
        fontSize: '13pt',
        ...centerVertically,
        "&.downloaded": {
          fontWeight: 500
        }
      },
      "& .gradeIcon": {
        color: '#d6e3f1',
        ...centerVertically,
        "&.downloaded": {
          color: '#ff47cb'
        }
      },
      "& .gradeLinks": {
        display: 'flex',
        "& .gradeLink": {
          marginLeft: 25
        }
      }
    },
    "& .gradesPaging": {
      flexGrow: 1,
      display: 'flex',
      paddingBottom: 10,
      flexDirection: 'column',
      justifyContent: 'flex-end'
    },
    "& .MuiTableBody-root": {
      "& .MuiTableRow-root": {
        "&:nth-of-type(odd)": {
          backgroundColor: '#f8fbfd'
        },
        "& .MuiTableCell-root": {
          color: '#4d5874',
          borderBottom: 0,
        }
      }
    }
  }
}
